import { CustomSearchState } from '@/types/models'
import { generateAlgoliaConfigurationFromSearchState } from '../../utils/search/generateAlgoliaConfigurationFromSearchState'
import { generateFacetFilters } from './generateFacetFilters'
import { isBoolean, isNonEmptyObject, isNonEmptyString } from '@/utils/checks'
import parseIntOrDefault from '@/utils/parseIntOrDefault'
import { getSessionStorage } from '@/utils/sessionStorage'
import { findPrimaryFocus } from '../primaryFocus/useCases/findPrimaryFocus'
import { PrimaryFocus } from '../primaryFocus/constant'
import { getAdOpsCookie } from '../useCases/adminBarInfo/adminBarUtils'

const normalizeSearchState = (
  searchState: CustomSearchState = {}
): CustomSearchState => {
  if (!isNonEmptyObject(searchState)) {
    return {
      configure: generateAlgoliaConfigurationFromSearchState()
    }
  }

  const parsedAroundLatLngViaIP =
    (isBoolean(searchState.configure?.aroundLatLngViaIP) &&
      searchState.configure?.aroundLatLngViaIP) ||
    (isNonEmptyString(searchState.configure?.aroundLatLngViaIP) &&
      searchState.configure.aroundLatLngViaIP === 'true')

  const parsedCustomLocationRadiusInMiles = parseIntOrDefault(
    searchState.customLocationRadiusInMiles
  )

  let primaryFocus = ''
  const primaryFocusMap = getSessionStorage('primaryFocusMap')
  if (isNonEmptyObject(primaryFocusMap)) {
    primaryFocus = findPrimaryFocus({
      searchState,
      primaryFocusMap: primaryFocusMap as unknown as Record<
        string,
        PrimaryFocus
      >
    })
  }

  const customLocationRadiusInMilesObject = isNaN(
    parsedCustomLocationRadiusInMiles
  )
    ? {}
    : { customLocationRadiusInMiles: parsedCustomLocationRadiusInMiles }

  const searchStateWithFacetFilters = {
    ...searchState,
    ...customLocationRadiusInMilesObject,
    configure: {
      ...(searchState.configure || {}),
      aroundLatLngViaIP: parsedAroundLatLngViaIP,
      facetFilters: generateFacetFilters({
        refinementList: searchState.refinementList || {}
      }),
      page: parseIntOrDefault(searchState.configure?.page, 0)
    }
  }

  const configure = generateAlgoliaConfigurationFromSearchState(
    searchStateWithFacetFilters,
    {
      primaryFocus,
      isAdOps: !!getAdOpsCookie()
    }
  )

  return {
    ...searchState,
    configure
  }
}

export default normalizeSearchState
